import { assetsDomain } from '../utils';

export const color = {
	black: '#000000',
	dark: '#10151c',
	white: '#ffffff',
	gray: '#969696',
	semiLightGray: '#ddd9d3',
	lightGray: '#fafafa',
	darkGray: '#323232',
	fbBlue: '#4065b4',
	darkBlue: '#002e56',
	blue: '#0059b5',
	lightBlue: '#0076ff',
	pickledBluewood: '#2c394c',
	cobaltBlue: '#1e242d',
	orange: '#ff7800',
	darkPurple: '#061751'
};

export const fontWeight = {
	bold: 700,
	semibold: 500,
	normal: 300,
	light: 200,
};

export const iconUrl = {
	facebook: `${assetsDomain}images/facebook.svg`,
	facebookShare: `${assetsDomain}images/ic-share-fb.svg`,
	icPlayTiny: `${assetsDomain}images/ic-play-tiny.svg`,
	icPlayMed: `${assetsDomain}images/ic-play-med.svg`,
	fbShareRnd: `${assetsDomain}images/ic-share-facebook-rnd.svg`,
	twitterShareRnd: `${assetsDomain}images/ic-share-twitter-rnd.svg`,
	linkShareRnd: `${assetsDomain}images/ic-share-link-rnd.svg`,
	emailShareRnd: `${assetsDomain}images/ic-share-email-rnd.svg`,
	upNext: `${assetsDomain}images/ic-playing.svg`,
	closeIconWhite: `${assetsDomain}images/ic-close-white.svg`,
	fsWhite: `${assetsDomain}images/ic-fs-white@2x.png`,
	icLive: `${assetsDomain}images/ic-live@2x.png`,
	fsgoWhite: `${assetsDomain}images/FoxSportsGO-white.svg`,
	fsgoBlack: `${assetsDomain}images/FoxSportsGO.svg`,
	icKey: `${assetsDomain}images/ic-key.svg`,
};



// WEBPACK FOOTER //
// ./react-app-src/shared/styles/vars.js